import { TSelectOption } from 'shared/services/types/common.types';

export const ROLE_USER = [
  {
    value: 'Администратор',
    label: 'Admin',
    labelDescription: 'Without restrictions'
  },
  {
    value: 'Менеджер',
    label: 'Manager',
    labelDescription:
      'It can manage multiple methods. Create and manage users. It cannot have an internal account'
  },
  {
    value: 'АгентМин',
    label: 'Agent plus',
    labelDescription:
      'It has the ability to use manual matching and add banks. All other functions are unavailable, he sees only those records that have passed through his accounts. Does not see other users. It can have only one method'
  },
  {
    value: 'Агент',
    label: 'Agent',
    labelDescription:
      'It is possible to add banks. Other functions are not available. He sees only those records that have passed through his accounts. Does not see other users. It can have only one method'
  },
  {
    value: 'Поддержка',
    label: 'Support',
    labelDescription:
      'It can view multiple methods. He can edit his own methods, as well as control their activation and deactivation. It sees the records of all users within its methods'
  }
] as TSelectOption[];
